<div class="root-container">
  <h2 class="title-h1">¿Qué te gustaría hacer?</h2>
  <div class="main-cards row">
    <div
      class="intranet-card col-md-6"
      [class.col-md-12]="i + 1 === items.length"
      *ngFor="let item of items; let i = index"
    >
      <app-card [item]="item"></app-card>
    </div>
  </div>
</div>
